module.exports = __webpack_public_path__ + "static/tetleys-sm-c5ab6e82d978d8bde89b36f43c9310fb.jpg";